@if (pageHeader.state$ | async; as state) {
  <div class="page-header">
    @if (pageHeader.shouldShowBack(state)) {
      <button
        mat-icon-button
        type="button"
        class="page-header__back"
        aria-label="Volver atrás"
        (click)="onBack(state)"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
    }

    <div class="page-header__heading">
      <h1 class="page-header__title">{{ state.title }}</h1>
      @if (state.subtitle) {
        <p class="page-header__subtitle">{{ state.subtitle }}</p>
      }
    </div>

    <span class="page-header__spacer"></span>

    @if (pageHeader.actions$ | async; as actionsTpl) {
      <!-- Desktop: actions inline. Mobile: collapsed into the ⋮ menu below.
           #actionsHost is inspected in ngAfterViewChecked so the ⋮ trigger
           only shows when the template actually rendered something. -->
      <div class="page-header__actions" #actionsHost>
        <ng-container [ngTemplateOutlet]="actionsTpl"></ng-container>
      </div>

      @if (hasActions) {
        <button
          mat-icon-button
          type="button"
          class="page-header__actions-trigger"
          [matMenuTriggerFor]="actionsMenu"
          aria-label="Más acciones"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu" class="page-header__actions-menu">
          <div
            class="page-header__actions-list"
            (click)="$event.stopPropagation()"
          >
            <ng-container [ngTemplateOutlet]="actionsTpl"></ng-container>
          </div>
        </mat-menu>
      }
    }

    @if (hasCounter(state)) {
      <span class="page-header__counter">
        {{ state.count }}
        @if (state.countLabel) {
          <span class="page-header__counter-label">{{ state.countLabel }}</span>
        }
        @if (state.countSuffix) {
          <span class="page-header__counter-suffix">{{ state.countSuffix }}</span>
        }
      </span>
    }
  </div>
}
